export enum PhotographerQueries {
	GET_PHOTOGRAPHERS = `
    query Photographers($companyId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $statusIds:[IdsInput!]!, $photographerIds:[IdsInput!]) {
        photographers(
            companyId: $companyId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            statusIds: $statusIds
            photographerIds: $photographerIds
            ) {
                nodes {
                    active
                    statusId
                    statusName
                    statusColor
                    companyId
                    companyName
                    shotCost
                    totalPaid
                    monthlyPaid
                    maxItems
                    discountThreshold
                    discountPercentage
                    hiredFrom
                    hiredUntil
                    automaticRenewal
                    personId
                    firstName
                    lastName
                    fullName
                    brands {
                        brandId
                        brandName
                        hasSizeGroup
                        personId
                        categories {
                            personId
                            brandId
                            categoryId
                            categoryName
                        }
                    }
                }
            }
        }
    `,
	GET_PHOTOGRAPHER_BY_ID = `
    query PhotographerById($companyId: Int!, $photographerId: Int!) {
        photographerById(companyId: $companyId, photographerId: $photographerId) {
            nodes {
                photographerContractId
                active
                statusId
                statusName
                statusColor
                companyId
                companyName
                shotCost
                totalPaid
                monthlyPaid
                maxItems
                discountThreshold
                discountPercentage
                hiredFrom
                hiredUntil
                automaticRenewal
                personId
                firstName
                lastName
                fullName
                brands {
                    personId
                    brandId
                    brandName
                    hasSizeGroup
                    categories {
                        personId
                        brandId
                        categoryId
                        categoryName
                    }
                }
            }
        }
    }
    `,
	GET_PHOTOGRAPHER_STATUS_NO_IDS = `
    query PhotographerStatus($companyId: Int!) {
        photographerStatus(companyId: $companyId) {
            nodes {
                id
                tag
                name
                description
                isCompanySelectable
                color
            }
        }
    }
    `,
	GET_PHOTOGRAPHER_STATUS = `
    query PhotographerStatus($companyId: Int!, $statusIds: [Int]) {
        photographerStatus(companyId: $companyId, where: { id: { in: $statusIds } }) {
            nodes {
                id
                tag
                name
                description
                isCompanySelectable
                color
            }
        }
    }
    `,
	GET_PHOTOGRAPHER_ORDERS = `
    query PhotographerOrders($companyId: Int!, $photographerId: Int!, $paginationPage: Int!, $paginationSize: Int!, $search: String!, $onGoing: Boolean!, $filters: OrdersListFiltersInput!) {
        photographerOrders(
            companyId: $companyId
            photographerId: $photographerId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            search: $search
            onGoing: $onGoing
            filters: $filters
        ) {
            nodes {
                orders {
                    orderId
                    orderNumber
                    orderStatusId
                    orderStatusName
                    dueDate
                    approvedShots
                    totalShots
                }
                total
            }
        }
    }
    `
}

